import isArray from 'lodash/isArray';
import merge from 'lodash/merge';
import Config from '@/config/index';
import { withOptimizely } from '../with-optimizely';
import { withLoggedInStatus } from '../with-logged-in-status';
import { withDevice } from '../with-device';
import { withUserTraits } from '../with-user-traits';
import { withCapturedPage } from '../with-captured-page';
export const enhanceData = (data) => {
    const newData = isArray(data) ? data : [data];
    return newData.map(item => {
        const optimizelyData = withOptimizely();
        return {
            ...item,
            additionalOptions: {
                ...merge(item.additionalOptions, {
                    context: {
                        app: { build: Config.release },
                        ...withCapturedPage(),
                    },
                }),
                ...optimizelyData,
            },
            properties: {
                ...withUserTraits(),
                ...item.properties,
                ...withDevice(),
                ...withLoggedInStatus(),
                app_experiment_id: optimizelyData.Optimizely.userId,
            },
        };
    });
};
